export default class LruCache {
  constructor() {
    this.limit = 500
    this.map = new Map()
  }

  has(key) {
    return this.map.has(key)
  }

  get(key) {
    if (!this.map.has(key)) {
      return undefined
    }

    const value = this.map.get(key)

    this.map.delete(key)
    this.map.set(key, value)

    return value
  }

  set(key, value) {
    if (this.map.has(key)) {
      this.map.delete(key)
    }

    this.map.set(key, value)

    if (this.map.size > this.limit) {
      const oldestKey = this.map.keys().next().value

      if (typeof oldestKey !== 'undefined') {
        this.map.delete(oldestKey)
      }
    }
  }

  delete(key) {
    this.map.delete(key)
  }

  clear() {
    this.map.clear()
  }
}
